import { render, staticRenderFns } from "./BoCustomerProductsPurchasedDatatable.vue?vue&type=template&id=4b63a092&scoped=true"
import script from "./BoCustomerProductsPurchasedDatatable.vue?vue&type=script&lang=js"
export * from "./BoCustomerProductsPurchasedDatatable.vue?vue&type=script&lang=js"
import style0 from "./BoCustomerProductsPurchasedDatatable.vue?vue&type=style&index=0&id=4b63a092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b63a092",
  null
  
)

export default component.exports